/**
 * /redeem-expired — Shown when a gift link has expired or is invalid.
 * Also used for /gift/already-redeemed via a prop.
 * No Mori shell.
 */

import { useTranslation } from "react-i18next";
import { MARKETING_URL } from "@/lib/urls";
import { PublicShell } from "@/components/PublicShell";

export default function RedeemExpiredPage() {
  const { t } = useTranslation();

  return (
    <PublicShell>
    <div className="flex flex-col items-center justify-center flex-1 px-6 py-16 text-center">
      <span className="text-5xl mb-6 block">🍂</span>

      <h1 className="text-2xl font-semibold text-foreground mb-4 leading-snug">
        {t("gift.expired.title")}
      </h1>

      <p className="text-base text-muted-foreground leading-relaxed max-w-sm">
        {t("gift.expired.bodyPrefix")}{" "}
        <a
          href="mailto:hello@meetmori.app"
          className="text-foreground underline underline-offset-2"
        >
          hello@meetmori.app
        </a>{" "}
        {t("gift.expired.bodySuffix")}
      </p>

      <div className="mt-10">
        <a
          href={MARKETING_URL}
          className="inline-block rounded-xl px-6 py-3 text-sm font-medium text-white transition-opacity hover:opacity-85"
          style={{ backgroundColor: "#7A9A7C" }}
        >
          {t("gift.backToMori")}
        </a>
      </div>
    </div>
    </PublicShell>
  );
}
